import { useEffect, useState } from "react";
import { useOrganization } from "stores/hooks/organization";
import { PrivacyPolicyModel } from "models/privacy-policy";
import PrivacyPolicyForm from "./privacy-policy-form";
import { adminDoGetPrivacyPolicy } from "services/admin/privacy-policy";

const PrivacyPolicyTab = () => {
  const organization = useOrganization();
  const [privacyPolicy, togglePrivacyPolicy] = useState<
    PrivacyPolicyModel | undefined
  >(undefined);

  const update = async () => {
    // get status
    const pp = await adminDoGetPrivacyPolicy();
    togglePrivacyPolicy(pp);
  };

  useEffect(() => {
    update();
  }, []);

  if (!organization || !privacyPolicy) {
    return null;
  }

  return <PrivacyPolicyForm privacyPolicy={privacyPolicy} />;
};

export default PrivacyPolicyTab;
